module.exports = __webpack_public_path__ + "img/wave_01.c58220b0.jpg";